import React from 'react'

import { LinkFactory, TokenReplacer } from '@vp/digital-token-replacer-lib-ubik'
import { BoundedContent, Box, Column, Divider, FlexBox, FluidImage, GridContainer, H2, H3, Hidden, ProgressiveImage, Row, Typography } from '@vp/swan'
import { getBlurredCloudinaryImage, getCloudinaryImage } from '../../../common/helpers/cloudinaryImageResizerHelper'
import { CommonFeatures } from '../../../../types/CommonFeatures'
import { LocalizedUrl } from '../../../../types/LocalizedUrl'
import { commonFeaturesToFeatureGroup } from '../../../../gatsby/mapCommonFeaturesToFeatureGroupModel'
import { appendSourceParam } from '../../../common/helpers/wixDomainsUrls'
import { sourceEnum } from '../../../common/enum/sourceEnum'

interface QuestionSectionProps {
  domainNameImportance: CommonFeatures
  whyThroughVista: CommonFeatures
  whyFeatures: CommonFeatures
  commonLocalizedUrls: { [key in string]: LocalizedUrl }
}
const QuestionsSection = (props: QuestionSectionProps) => {
  const {
    commonLocalizedUrls: { wixWebsitesUrlLocalized },
    whyThroughVista,
    domainNameImportance,
    whyFeatures,
  } = props

  const whyThroughVistaFeatures = whyFeatures ? (commonFeaturesToFeatureGroup(whyFeatures).features ?? []) : []
  return (
    <>
      {/* Wix Domains PDP  What is a domain name and why is it important? */}
      {domainNameImportance && (
        <BoundedContent>
          <Typography component="article" mt={{ lg: 8 }}>
            <GridContainer mb={6}>
              <Row>
                <Column offset={0} span={12} spanMd={5} spanLg={5} spanXl={5}>
                  <H2 fontSize="x2large" fontWeight="bold" mt={7}>
                    {domainNameImportance.title}
                  </H2>
                  <Typography component="p" mt={6}>
                    {domainNameImportance.description}
                  </Typography>
                </Column>
                <Column span={12} spanMd={7} spanLg={7} spanXl={7}>
                  <Hidden sm xs style={{ height: '100%' }}>
                    <FlexBox alignItems="center" flexWrap="wrap" style={{ height: '100%' }} justifyContent="center">
                      {typeof domainNameImportance?.mediaLink?.[1].secure_url === 'string' && (
                        <ProgressiveImage
                          mt={7}
                          style={{ width: '100%' }}
                          placeholder={getBlurredCloudinaryImage(domainNameImportance.mediaLink?.[1].secure_url)}
                          src={getCloudinaryImage(domainNameImportance.mediaLink?.[1].secure_url)}
                        >
                          {(image) => <FluidImage src={image.src} alt="" />}
                        </ProgressiveImage>
                      )}
                    </FlexBox>
                  </Hidden>
                </Column>
              </Row>
            </GridContainer>
            <Divider />
          </Typography>
        </BoundedContent>
      )}
      {/* Wix Domains PDP  Why get your domain */}
      {whyThroughVista && (
        <BoundedContent>
          <GridContainer>
            <Row>
              <Column span={12}>
                <H2 fontSize="x2large" fontWeight="bold" mt={7}>
                  {whyThroughVista.title}
                </H2>
                <Typography component="p" mt={6}>
                  {whyThroughVista.description}
                </Typography>
              </Column>
            </Row>
            <Row mt={7} className="wix-domains-pdp__domains-why-vista__container">
              {whyThroughVistaFeatures.map((feature, index) => {
                const iconSrc = feature.icons?.[0]?.url || feature.mediaUrl
                const featureKey = feature.key ?? `${feature.title}-${index}`

                return (
                  <Column key={featureKey} span={4} spanXs={12} spanSm={4} spanMd={4} spanLg={4} spanXl={4} mb={{ xs: 6, sm: 6, md: 0 }}>
                    <Box className="wix-domains-pdp__domains-why-vista__feature">
                      {iconSrc && <FluidImage src={iconSrc} alt={feature.altText} width={50} height={50} />}
                      <H3 fontSize="large" fontWeight="bold" m={0}>
                        {feature.title}
                      </H3>
                      {feature.description && (
                        <Typography component="p" fontSize="small" m={0}>
                          <span>{feature.description}</span>
                        </Typography>
                      )}
                    </Box>
                  </Column>
                )
              })}
            </Row>
            <Row>
              <Column span={12}>
                <Typography component="p" mt={7} mb={7} fontWeight="bold">
                  {typeof whyThroughVista?.features?.[0].name === 'string' && (
                    <TokenReplacer
                      template={whyThroughVista.features[0].name}
                      replacements={{
                        link: LinkFactory({
                          anonymousPlanPickerUrl: appendSourceParam(wixWebsitesUrlLocalized.url, sourceEnum.DOMAINS_PDP_WHY_VISTA),
                        }),
                      }}
                      convertMarkdown
                    />
                  )}
                </Typography>
              </Column>
            </Row>
          </GridContainer>
        </BoundedContent>
      )}
    </>
  )
}

export default QuestionsSection
